module.exports = __webpack_public_path__ + "static/media/sample-of-certificate-pipe-2-compressed.3d9e7d25.jpg";